import $ from 'jquery';

$(document).ready(function() {
  $('#form-anchor').click(function() {
    var elementClick = $('.subscription-page');
    var destination = $(elementClick).offset().top;
    $('html:not(:animated),body:not(:animated)').animate(
      {
        scrollTop: destination
      },
      800
    );
  });

  $('.follow').on('click', function(e) {
    e.preventDefault();
    const $currentButton = $(this);
    let db_action = 'add';

    if ($currentButton.hasClass('cancel')) {
      db_action = 'unset';
    }

    let data = {
      action: 'follow_by_ajax',
      type: $currentButton.data('type'),
      db_action: db_action,
      id: $currentButton.data('id'),
      user: window.global_settings.user,
      security: window.global_settings.security
    };

    $.post(window.ajaxurl, data, function(response) {
      if (response.result === 'success') {
        if ($currentButton.hasClass('cancel')) {
          if ($currentButton.closest('.subscription-form__container')) {
            $currentButton.closest('.subscription-form__container').remove();
            if ($currentButton.siblings('.btn.follow')) {
              $currentButton.addClass('hidden');
              $currentButton.siblings('.btn.follow').removeClass('hidden');
            }

            if (
              $('.subscription-list-authors').children(
                '.subscription-form__container'
              ).length <= 0
            ) {
              $('.subscription-list-authors').html(
                'Ви ще не підписані на жодного автора'
              );
            }

            if (
              $('.subscription-list-rubric').children(
                '.subscription-form__container'
              ).length <= 0
            ) {
              $('.subscription-list-rubric').html(
                'Ви ще не підписані на жодну рубрику'
              );
            }
          } else {
            $currentButton.closest('.dashboard__article').remove();
          }
        } else {
          if ($currentButton.siblings('.btn.cancel')) {
            $currentButton.addClass('hidden');
            $currentButton.siblings('.btn.cancel').removeClass('hidden');
          }
        }
      } else {
        $(this)
          .closest('div')
          .find('.info-box')
          .html('Помилка')
          .addClass('error');
      }
    });
    return false;
  });

  $('.hide-click input').on('click', function() {
    let filterAdrs = $(this).attr('data-tab');
    $(`.full-container[data-tab="${filterAdrs}"]`).toggleClass('closed');
  });

  // checked and cashes files on page and throws to pc

  $('.subscription-authors__info-link follow cancel').on('click', function() {
    $(this)
      .parent('subscription-form__container')
      .remove();
  });

  $('.right-alert__link follow cancel').on('click', function() {
    $(this)
      .parent('subscription-form__container')
      .remove();
  });

  $('.btnRaiting follow cancel').on('click', function() {
    $(this)
      .parent('dashboard__article')
      .remove();
  });

  if (window.location.pathname === '/osobystyi-kabinet/') {
    var $period_month = $(this)
      .find('.subs-rate__block-input:checked')
      .val();
    localStorage.setItem('subscription-term', $period_month);
  }

  $('.subs-rate__block').on('click', function() {
    var $period_month = $(this)
      .find('.subs-rate__block-input')
      .val();
    localStorage.setItem('subscription-term', $period_month);

    // remove input when checked payment for 3 month

    if ($('.subs-content.current').attr('data-tab') === 'subs-1') {
      if ($(this).find('.hide-payment').length > 0) {
        hidePaymentMethod('doc');
      } else {
        openPaymentMethod('doc');
      }
    }

    if (
      $('.eventVisa')
        .siblings('input[type="radio"]')
        .is(':checked')
    ) {
      $('.input-with-card').addClass('closed');
    }
  });

  function hidePaymentMethod(method) {
    const $paymentMethodBlock = $(`.subs-content.current .${method}-payment`);
    $paymentMethodBlock.addClass('hide');

    if ($paymentMethodBlock.find('input:checked').length > 0) {
      $paymentMethodBlock
        .siblings(':first')
        .find('input[type="radio"]')
        .attr('checked', true)
        .trigger('click');
    }
  }

  function openPaymentMethod(method) {
    $(`.subs-content.current .${method}-payment`).removeClass('hide');
  }

  if ($('.hide-payment').is(':checked')) {
    hidePaymentMethod('doc');
  } else {
    openPaymentMethod('doc');
  }
});

$('.payment form').each(function() {
  $(this).validate({
    lang: 'uk',
    ignore: '.closed input',
    rules: {
      billing_company: {
        required: true
      },
      company_code: {
        required: true
      },
      billing_first_name: {
        required: true
      },
      billing_last_name: {
        required: true
      },
      user_email: {
        required: true
      },
      billing_phone: {
        required: true
      },
      billing_postcode: {
        required: true
      },
      billing_state: {
        required: true
      },
      billing_city: {
        required: true
      },
      street: {
        required: true
      },
      building: {
        required: true
      },
      code: {
        required: true
      },
      billing_address_1: {
        required: true
      },
      billing_address_2: {
        required: true
      }
    }
  });

  // if there are non-valid elements prevent the form from submitting
  $(this).on('submit', function(e) {
    if ($(this).valid()) {
      $(this).addClass('validation-success');
    } else {
      e.stopImmediatePropagation();
    }
  });
});

// Validate user data saving form
$('#user-data').validate();

// if there are non-valid elements prevent the form from submitting
$('#user-data').on('submit', function(e) {
  if ($(this).valid()) {
    $(this).addClass('validation-success');
  } else {
    e.stopImmediatePropagation();
  }
});
